import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../Button';
import Logo from '../../Logo';
import getConfig from '../../../../util/config';
import { getAsset } from '../../../../util/assets';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  imageContainerClassName: PropTypes.string,
  withCTA: PropTypes.bool,
  buttonText: PropTypes.string,
  buttonTo: PropTypes.string,
  logoSrc: PropTypes.string,
  imageDisabled: PropTypes.bool,
};

const Wrapper = ({
  children,
  className,
  contentClassName,
  imageContainerClassName,
  withCTA = true,
  buttonText = 'Sign in',
  buttonTo = '/shutterbug/signin',
  logoSrc = '/waldo-logo.svg',
  imageDisabled = false,
}) => {
  const { marcomUrl } = getConfig();
  const classes = classNames({
    'signup-album-layout-wrapper': true,
    'signup-album-layout-wrapper-no-image': imageDisabled,
    [className]: !!className,
  });

  const contentClasses = classNames({
    'signup-album-layout-content': true,
    [contentClassName]: !!contentClassName,
  });

  const imageContainerClasses = classNames({
    'signup-album-layout-image': true,
    [imageContainerClassName]: !!imageContainerClassName,
  });

  return (
    <div className={classes}>
      <div className={contentClasses}>
        <div className="signup-album-layout-title">
          {logoSrc && (
            <Logo
              logoSrc={getAsset(logoSrc)}
              linksTo={marcomUrl}
              externalLink
            />
          )}
          {withCTA && (
            <Button btnSize="sm" btnStyle="white" to={buttonTo}>
              {buttonText}
            </Button>
          )}
        </div>
        {children}
      </div>

      <div className={imageContainerClasses}>
        {withCTA && (
          <Button btnStyle="white" to={buttonTo}>
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};

Wrapper.propTypes = propTypes;

export default Wrapper;
